<template lang="jade">
  component(":is"="type" ":fdata"="fdata" ":tmpl"="template")
</template>

<script>
  import _ from 'lodash'
  import edit from './edit'
  import index from './index'

  export default {
    data () {
      return {
        uid: this.$parent.uid
      }
    },
    props: {
      fdata: {
        type: Object,
        coerce (x) {
          let columns = x.templates.map(xs => xs.label)
          let data = x.templates.map(xs => x.data[xs.field])
          let numRows = _.head(data).length
          let numCols = data.length
          let rows = [x.templates]
          if (numRows > 0) {
            rows = _.times(numRows, idx => {
              return _.times(numCols, n => {
                let value = _.has(data, [n, idx]) ? data[n][idx].value : ''
                return Object.assign({}, x.templates[n], {value, row: idx})
              })
            })
          }
          return Object.assign(x, {columns, rows})
        }
      },
      template: {
        type: Number,
        default: 1
      }
    },
    computed: {
      type () {
        return this.fdata.editable ? 'edit' : 'index'
      }
    },
    components: { edit, index }
  }
</script>



// WEBPACK FOOTER //
// group.vue?0ba09165